import styles from "../style";
import { Reveal } from "./reveal";

const Heroserv = () => {
  return (
    <div className={` bg-fourth w-full flex flex-col md:flex-row md:gap-20 gap-10 items-start justify-center py-40 px-10`}>  
      <Reveal className="flex flex-col gap-4 items-start md:items-end py-40 pb-16">
        <h2 className="text-sm font-semibold text-primary">
          Our Impact
        </h2>
        <h2 className="pt-4 xs:text-md text-md font-semibold max-w-[300px] text-white">
          Empowering
        </h2>
        <h2 className="xs:text-md text-md font-semibold max-w-[300px] text-secondary">
          Africa's Future
        </h2>
      </Reveal>
              
      <Reveal>
        <div className={`pb-14 flex flex-col items-start `}>
          <p className={`text-primary xs:text-mm text-sm font-semibold text-start max-w-[600px]`}>
            Aegis Education Group provides consultancy led training and advisory support to help schools move from policy awareness to confident, consistent day to day practice.
          </p>

          <p className={`my-10 text-primary xs:text-mm text-sm text-start max-w-[600px]`}>
            Aegis Education Group was founded by Emilianne Gathitu, a school leader, educator and safeguarding practitioner with international school experience across teaching, leadership, safeguarding, staff development and systems improvement.
          </p>

          <span className="xs:mb-6 border-b border-2 border-second w-[100px]"></span> 
    
        </div>        
      </Reveal>    
    </div>
  );
};

export default Heroserv;
